import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-session-logout',
  templateUrl: './session-logout.component.html',
  styleUrls: ['./session-logout.component.scss']
})
export class SessionLogoutComponent implements OnInit {

  constructor(public configService: ConfigService) { }

  ngOnInit(): void {
  }

}
